import { Popup } from "../Popup"

export type InfoPopoverButtonProps = {
    disabled?: boolean
    children: React.ReactNode
}

export function InfoPopoverButton({ children, disabled }: InfoPopoverButtonProps) {
    return (
        <Popup disabled={disabled} popupContent={() => <>{children}</>} popupCssClass="info-popover-button--popup">
            <span className="info-popover-button--icon fa-solid fa-circle-info" />
        </Popup>
    )
}
